import type { BestPrices } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";

export const getLowestPriceIncVat = (
	selectedPrice: number,
	pricesArray: BestPrices[]
) => {
	const lowerPrice = pricesArray.find(
		(item) => item.PriceIncVat <= selectedPrice
	);
	return lowerPrice ? lowerPrice.PriceIncVat : null;
};
